import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { getCountryName } from 'utils';

const CountryLabel = React.memo(
  ( { country, locale } ) => getCountryName( country, locale ),
);

const mapStateToProps = ( { settings } ) => ( {
  locale: _.get( settings, 'locale.locale' ),
} );

export default connect( mapStateToProps )( CountryLabel );
